import * as React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/system';
import { useButton } from '@mui/base/useButton';
import { ButtonProps } from '@mui/base/Button';



import { SvgIconComponent } from "@mui/icons-material";

// @mui/icons-material
// import { Button, ButtonProps, buttonClasses } from '@mui/base/Button';
// import { SvgIconProps } from "@material-ui/core/SvgIcon"; 
// import { SvgIconProps } from '@material-ui/core';
// import SvgIcon, { SvgIconProps } from "@mui/icons-material/";
// import theme from '../../theme';
// import SvgIcon from '@mui/material/SvgIcon';

export interface KsrgrButtonProps extends ButtonProps {
  text:string;
  onClick?: ()=>void;
  startIcon?:JSX.Element;
}

const CustomButtonRoot = styled('button')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5;
    background-color: ${theme.palette.primary.main};
    padding: 8px 16px;
    border-radius: 8px;
    color: white;
    transition: all 150ms ease;
    cursor: pointer;
    border: 1px solid ${theme.palette.primary.main};
    box-shadow: 0 2px 1px ${theme.palette.primary.dark}, 
    inset 0 1.5px 1px ${theme.palette.primary.main}, inset 0 -2px 1px ${theme.palette.primary.light};
  
    &:hover {
      background-color: ${theme.palette.primary.light};
    }
  
    &.active {
      background-color: ${theme.palette.primary.light};
      box-shadow: none;
      transform: scale(0.99);
    }
  
    &.focusVisible {
      box-shadow: 0 0 0 4px ${theme.palette.primary.dark};
      outline: none;
    }
  
    &.disabled {
      background-color: rgba(0, 0, 0, 0.12);
      color: rgba(0, 0, 0, 0.26);
      border: 0;
      cursor: default;
      box-shadow: none;
      transform: scale(1);
    }
  `,
);

  const CustomButton = React.forwardRef(function CustomButton(
    props: ButtonProps,
    ref: React.ForwardedRef<any>,
  ) {
    const { children, disabled } = props;
    const { active, focusVisible, getRootProps } = useButton({
      ...props,
      rootRef: ref,
    });
  
    return (
      <CustomButtonRoot
        {...getRootProps()}
        className={clsx({
          active,
          disabled,
          focusVisible,
        })}
      >
        {children}
      </CustomButtonRoot>
    );
  });

  export default function KsrgrButton(props:KsrgrButtonProps) {
    let btnprops = props;
    if(btnprops.onClick===undefined || btnprops.onClick===null) btnprops.onClick= function(){}
    //if(btnprops.disabled===undefined || btnprops.disabled===null) btnprops.disabled=false;
    //else btnprops.disabled=props.disabled;
    return (
      <CustomButton {...btnprops} >{btnprops.children}</CustomButton>
    );
  }
